<script>
import { downloadDailyShareDataXlsx, loadKeiyoFiveMonthShareData } from '@/api/data'
import moment from 'moment'

export default {
  name: 'DailyData',
  data () {
    return {
      showCalendar: false,
      data: {}
    }
  },
  created () {
    this.loadData(moment().format('YYYY-MM'))
    window.showSetting = function (e) {
      console.log(e)
    }
  },
  methods: {
    loadData (m) {
      loadKeiyoFiveMonthShareData({ month: m }).then(res => {
        this.data = res.data
        this.showCalendar = true
      })
    },
    showSetting () {

    },
    onPanelChange (e) {
      this.loadData(e.format('YYYY-MM'))
    },
    getDayData (m) {
      const day = m.format('YYYY-MM-DD')

      return this.data[day] || { }
    },
    downloadXlsxFile (info) {
      const hide = this.$message.loading(this.$t('user.excel.exporting'), 0)
      downloadDailyShareDataXlsx({ id: info.id }).then(res => {
        hide()
        this.saveResultAsExcel(res, `Alcohol_Check_${info.date}.xlsx`)
      })
    },
    headerRender ({ value, type, onChange, onTypeChange }) {
      const start = 0
      const end = 12
      const monthOptions = []

      const current = value.clone()
      const localeData = value.localeData()
      const months = []
      for (let i = 0; i < 12; i++) {
        current.month(i)
        months.push(localeData.monthsShort(current))
      }

      for (let index = start; index < end; index++) {
        monthOptions.push(
          <a-select-option class='month-item' key={`${index}`}>
            {months[index]}
          </a-select-option>
        )
      }
      const month = value.month()

      const year = value.year()
      const options = []
      for (let i = year - 10; i < year + 10; i += 1) {
        options.push(
          <a-select-option key={i} value={i} class='year-item'>
            {i}
          </a-select-option>
        )
      }
      // const btnStr = this.$t('user.alc.xlsx.auto.send')
      // return (
      //   <div class='calendar-header'>
      //     <a-row type='flex' justify='space-between'>
      //       <a-col>
      //         <a-select
      //           size='medium'
      //           dropdownMatchSelectWidth={false}
      //           class='my-year-select'
      //           onChange={newYear => {
      //             const now = value.clone().year(newYear)
      //             onChange(now)
      //           }}
      //           value={String(year)}
      //         >
      //           {options}
      //         </a-select>
      //         <a-select
      //           size='medium'
      //           class='margin-left-16'
      //           dropdownMatchSelectWidth={false}
      //           value={String(month)}
      //           onChange={selectedMonth => {
      //             const newValue = value.clone()
      //             newValue.month(parseInt(selectedMonth, 10))
      //             onChange(newValue)
      //           }}
      //         >
      //           {monthOptions}
      //         </a-select>
      //       </a-col>
      //     </a-row>
      //   </div>
      // )
      return (
        <div class='calendar-header'>
          <a-row type='flex' justify='space-between'>
            <a-col>
              <a-select
                size='medium'
                dropdownMatchSelectWidth={false}
                class='my-year-select'
                onChange={newYear => {
                  const now = value.clone().year(newYear)
                  onChange(now)
                }}
                value={String(year)}
              >
                {options}
              </a-select>
              <a-select
                size='medium'
                class='margin-left-16'
                dropdownMatchSelectWidth={false}
                value={String(month)}
                onChange={selectedMonth => {
                  const newValue = value.clone()
                  newValue.month(parseInt(selectedMonth, 10))
                  onChange(newValue)
                }}
              >
                {monthOptions}
              </a-select>
            </a-col>
          </a-row>
        </div>
      )
    }
  }
}
</script>

<template>
  <div class="daily-data-page">
    <div class="calendar-card">
      <a-calendar @panelChange="onPanelChange" :fullscreen="true" :header-render="headerRender" v-if="showCalendar">
        <div slot="dateCellRender" slot-scope="value" class="day-cell">
          <div v-if="getDayData(value).date" class="day-cell__inner">
            <div class="day-cell__progress">
              <a-progress
                type="circle"
                :width="58"
                :stroke-color="{
                  '0%': '#1E9E5A',
                  '100%': '#6FCF97',
                }"
                :percent="getDayData(value).percent"
              >
                <template #format="percent">
                  <div class="day-cell__percent">{{ getDayData(value).percent }}%</div>
                  <div class="day-cell__ratio">
                    <span :title="$t('user.alc.test.num').replace('{count}', getDayData(value).test_u_num)">{{ getDayData(value).test_u_num }}</span>
                    <span class="day-cell__divider">/</span>
                    <span :title="$t('user.bind.num').replace('{count}', getDayData(value).total_u_num)">{{ getDayData(value).total_u_num }}</span>
                  </div>
                </template>
              </a-progress>
            </div>
            <div v-if="getDayData(value).download_tag" class="day-cell__download">
              <a :title="$t('user.alc.xlsx.download.tip')" @click="downloadXlsxFile(getDayData(value))">
                <a-icon type="download" /> {{ $t('user.action.download') }}
              </a>
            </div>
          </div>
          <div v-if="getDayData(value).limited_user > 0 && getDayData(value).test_u_num > 0" class="day-cell__warning">
            <a-tooltip>
              <template slot="title">
                {{ getDayData(value).limited_user }}{{ $t('user.alc.limited.user') }}
              </template>
              <a-icon type="warning" />
            </a-tooltip>
          </div>
        </div>
      </a-calendar>
    </div>
  </div>
</template>

<style scoped lang="less">
@primary: #0A76C6;
@radius: 6px;
@shadow-card: 0 1px 2px rgba(16, 32, 48, 0.06), 0 1px 3px rgba(16, 32, 48, 0.04);
@text-secondary: #5b6b7b;
@text-tertiary: #8b9aa9;
@line-2: #edf1f5;
@transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);

.daily-data-page {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.calendar-card {
  /* 和其它菜单页的卡片同一套 chrome：只有阴影、不描边，
     否则日历页会比相邻页多出一圈线 */
  background: var(--surface);
  border-radius: @radius;
  box-shadow: @shadow-card;
  padding: 16px 20px 20px;
}

.my-year-select {
  width: 80px;
}

/* 全屏日历（.ant-fullcalendar）不在主题层的覆盖范围内，默认还是暖黑字 + antd 默认蓝，
   这里把它拉回台面的墨水色。
   注意：vue-loader 是 15.9，只认 ::v-deep；:deep(...) 会被原样输出成未知伪类，整条规则作废。
   headerRender 返回的 .calendar-header 是 JSX 建的，不带 scope 属性，同样必须穿透 */
::v-deep .calendar-header {
  padding: 0 2px 12px;
  margin-bottom: 8px;
  border-bottom: 1px solid @line-2;
}

::v-deep .ant-fullcalendar-header {
  padding: 0;
}

::v-deep .ant-fullcalendar {
  background: transparent;
}

/* 星期行是表头标签，小一号、拉开字距，让它退到日期后面 */
::v-deep .ant-fullcalendar-column-header {
  padding: 6px 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: @text-tertiary;
}

::v-deep .ant-fullcalendar-column-header-inner {
  font-weight: 600;
}

::v-deep .ant-fullcalendar-cell,
::v-deep .ant-fullcalendar-column-header {
  border-color: @line-2;
}

/* 日期数字是这台仪器的刻线，等宽字体让整月上下对齐 */
::v-deep .ant-fullcalendar-value,
::v-deep .ant-fullcalendar-date {
  font-family: var(--font-data);
  font-size: 12px;
  color: var(--ink);
}

::v-deep .ant-fullcalendar-today .ant-fullcalendar-date {
  border-color: var(--brand);
  border-radius: 3px;
  color: var(--brand);
  font-weight: 600;
}

::v-deep .ant-fullcalendar-selected-day .ant-fullcalendar-date {
background: var(--brand-tint);
  border-radius: 3px;
 color: var(--brand);
}

::v-deep .ant-fullcalendar-last-month-cell .ant-fullcalendar-value,
::v-deep .ant-fullcalendar-next-month-btn-day .ant-fullcalendar-value {
  color: var(--ink-3);
}

.day-cell {
  position: relative;
  height: 100%;

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  &__progress {
    display: flex;
    justify-content: center;
  }

  &__percent {
    font-family: var(--font-data);
    font-size: 12px;
    font-weight: 600;
    color: var(--ink);
    line-height: 1.2;
  }

  &__ratio {
    font-family: var(--font-data);
    font-size: 10px;
    color: @text-tertiary;
    line-height: 1.2;
  }

  &__divider {
    padding: 0 1px;
    color: @text-tertiary;
  }

  &__download {
    text-align: center;

    a {
      font-size: 11px;
      color: var(--brand);
      transition: color @transition;

      &:hover {
        color: var(--brand-dark);
      }
    }
  }

  &__warning {
    position: absolute;
    bottom: 4px;
    left: 6px;

    .anticon {
      color: var(--fail);
      font-size: 13px;
    }
  }
}
</style>
